(function() {
  // 'use strict';

  var scrollTop = $(window).scrollTop();



  /* --------------------------------------------
  スクロールに合わせて動画を再生
  -------------------------------------------- */
  var video;
  var videoPos;
  var trigger;
  function scrolledMovPlay(){
    scrollTop = $(window).scrollTop();
    $('.js-mov').each(function(){
      video = $(this);
      videoHeight = $(this).height();
      videoPos = $(this).offset().top;
      winH = $(window).height();
      trigger = videoPos - (winH - 30);
      if(scrollTop > trigger){
        video[0].play();
      }

    });
  }

  /* --------------------------------------------
  load時
  -------------------------------------------- */
  $(window).on('load', function() {
    scrolledMovPlay();
  });

  /* --------------------------------------------
  resize時
  -------------------------------------------- */
  $(window).on('resize', function() {
    scrolledMovPlay();
  });

  /* --------------------------------------------
  scroll時
  -------------------------------------------- */
  $(window).on('scroll', function() {
    scrolledMovPlay();
  });


}());
